/**
 * pendingImport.ts
 *
 * Module-level singleton for passing a File object across React Router navigation.
 * File objects cannot be serialized into router state, so we store them here.
 *
 * Usage:
 *   // On the source page (e.g. ProjectsPage):
 *   setPendingImport(file)
 *   navigate(`/projects/${id}/import`)
 *
 *   // On the target page (ImportWorkbookPage), called once on mount:
 *   const file = takePendingImport()  // returns File | null and clears the store
 */

let _file: File | null = null

export function setPendingImport(file: File): void {
  _file = file
}

/** Returns the pending file and clears the store. Returns null if none set. */
export function takePendingImport(): File | null {
  const f = _file
  _file = null
  return f
}
